var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiCallService } from './api-call.service';
import { BaseApiService } from './base-api.service';
var CameraService = /** @class */ (function (_super) {
    __extends(CameraService, _super);
    function CameraService(apiCallService) {
        var _this = _super.call(this) || this;
        _this.apiCallService = apiCallService;
        return _this;
    }
    Object.defineProperty(CameraService.prototype, "currentCameraUserId", {
        get: function () {
            return localStorage.getItem('currentCameraUserId');
        },
        set: function (id) {
            localStorage.setItem('currentCameraUserId', id);
        },
        enumerable: true,
        configurable: true
    });
    CameraService.prototype.moveRelative = function (id, direction, camera_user_uuid) {
        this.validateId(id, 'id');
        return this.apiCallService.post('/cameras/' + id + '/camera_control/move_relative', {
            direction: direction,
            camera_user_uuid: camera_user_uuid
        }, undefined);
    };
    CameraService.prototype.moveContinuous = function (id, direction, camera_user_uuid) {
        this.validateId(id, 'id');
        return this.apiCallService.post('/cameras/' + id + '/camera_control/move_continuous', {
            direction: direction,
            camera_user_uuid: camera_user_uuid
        }, undefined);
    };
    CameraService.prototype.moveStop = function (id, camera_user_uuid) {
        this.validateId(id, 'id');
        return this.apiCallService.post('/cameras/' + id + '/camera_control/move_stop', { camera_user_uuid: camera_user_uuid }, undefined);
    };
    CameraService.prototype.requestControl = function (id, data) {
        this.validateId(id, 'id');
        return this.apiCallService.post('/cameras/' + id + '/camera_control', data);
    };
    CameraService.prototype.checkQueueStatus = function (id, camera_user_uuid) {
        return this.apiCallService.post('/cameras/' + id + '/camera_control/check', {
            camera_user_uuid: camera_user_uuid
        });
    };
    CameraService.prototype.leaveQueue = function (id, camera_user_uuid) {
        return this.apiCallService.delete('/cameras/' + id + '/camera_control', {
            camera_user_uuid: camera_user_uuid
        });
    };
    return CameraService;
}(BaseApiService));
export { CameraService };



// WEBPACK FOOTER //
// ./src/app/common-theme/api/camera.service.ts.pre-build-optimizer.js